import React from 'react'; 

const discoverUnity = () => {
    return (
<section className="discover-unity" id="descubra-unidade">
    <div className="container">
        <div className="row py-5">
            <div className="col-12 text-center title-discover">Descubra a Unidade Móvel de Saúde Ideal para Você</div>
            <div className="col-12 text-center py-3 subtitle-discover">Alugue com a Saúde Móvel Brasil e tenha uma unidade personalizada para atender às suas necessidades</div>
            <div className="col-12 text-center d-flex justify-content-center">
                <div className="col-6 col-lg-3"> <a href="https://wa.me/556598106742" target="_blank" className="btn btn-other text-uppercase d-block py-3 rounded-0"><strong> entre em contato </strong></a> </div>
            </div>
        </div>
    </div>
</section>
    );
};

export default discoverUnity;